import React, { Component } from "react";
import { connect } from "react-redux";
import { View, StyleSheet } from "react-native";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/AreaActions";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import arTheme from "../argon-ui/Theme";

import {
  faExclamationTriangle,
  faTrashAlt,
} from "../../assets/consts/faCharCodes";
import Loading from "../components/Loading";
import { SimpleIcon } from "../components_v2/Buttons";
import * as AreaHelper from "../actions/AreaHelper";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
const axios = require("axios").default;

class AreaRemoveScreen extends Component {
  constructor(props) {
    super(props);
    let areaId = 0;
    if (
      this.props.navigation &&
      this.props.navigation.state &&
      this.props.navigation.state.params
    ) {
      areaId = this.props.navigation.state.params.areaId || 0;
    }
    this.state = {
      accessToken: null,

      areaId,
      areaName: "",
      subAreas: 0,
      devices: 0,
      isArmed: false,

      isRoot: false,

      rootId: 0,
      rootName: "",
      hasRootAccess: false,

      parentId: 0,
      parentName: "",
      hasParentAccess: false,

      errors: [],

      isLoading: true,

      subAreasReplacementAreaId: null,
      subAreasReplacementAreaUId: null,

      devicesReplacementAreaId: null,
      devicesReplacementAreaUId: null,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreaRemove"),
  });
  componentDidMount() {
    const { currentServer } = this.props.AppReducer;
    if (!this.state.areaId) this.navigation.goBack();

    var area = AreaHelper.findAreaById(
      this.props.AreaReducer.areas,
      this.state.areaId
    );
    if (area) {
      // console.log("area did mount", area);

      let {
        areaId,
        areaUId,
        areaName,
        isArmed,
        isMainArea,
        parentAreaId,
        parentAreaUId,
        allSubAreasCount,
      } = area;
      var devicesCount = area.devices?.length || area.uDevices?.length;
      var subAreasCount = allSubAreasCount || area.subAreas.length;
      var isRoot = isMainArea && (!parentAreaId || !parentAreaUId);
      var hasRootAccess = false;
      var rootId = 0;
      var rootName = "";
      if (!isRoot) {
        var rootArea = this.props.AreaReducer.areas.filter(
          (a) => a.isMainArea && !a.parentAreaId
        )[0];
        if (rootArea) {
          rootId = rootArea.areaId || rootArea.areaUId;
          rootName = rootArea.areaName;
          hasRootAccess = true;
        }
      }

      var errors = [];
      if (isRoot)
        errors.push(translate("area.removeErrors.CannotRemoveRootArea"));
      else if (isArmed)
        errors.push(translate("area.removeErrors.CannotRemoveArmedAreas"));

      var parentId = 0;
      var parentUId = 0;
      var parentName = "";
      var hasParentAccess = false;
      if (parentAreaId > 0 || parentAreaUId) {
        var parent = AreaHelper.findAreaById(
          this.props.AreaReducer.areas,
          parentAreaId || parentAreaUId
        );
        if (parent) {
          // do not set parentId until making sure user has access to parent
          parentId = parent.areaId || parent.areaUId;
          parentUId = parent.areaUId;
          parentName = parent.areaName;
          hasParentAccess = true;
        }
      }

      if (!hasParentAccess && !hasRootAccess && devicesCount > 0) {
        errors.push(translate("area.removeErrors.CannotRemoveDevices"));
      }

      if (!hasParentAccess && subAreasCount > 0) {
        errors.push(translate("area.removeErrors.CannotRemoveSubAreas"));
      }

      this.setState({
        accessToken: currentServer.accessToken,
        isLoading: false,
        areaId,
        areaUId,
        areaName,
        isArmed,
        isRoot,
        devices: devicesCount,
        subAreas: subAreasCount,
        parentId,
        parentName,
        errors,
        hasParentAccess,
        hasRootAccess,
        rootId,
        rootName,
        subAreasReplacementAreaId:
          hasParentAccess && subAreasCount > 0 ? parentId : null,
        subAreasReplacementAreaUId:
          hasParentAccess && subAreasCount > 0 ? parentUId : null,
        devicesReplacementAreaId:
          hasParentAccess && devicesCount > 0 ? parentId : null,
        devicesReplacementAreaUId:
          hasParentAccess && devicesCount > 0 ? parentUId : null,
      });
    } else {
      this.navigation.goBack();
    }
  }

  goBack() {
    this.props.navigation.goBack();
  }

  submit() {
    let {
      areaId,
      areaUId,
      devicesReplacementAreaId,
      devicesReplacementAreaUId,
      subAreasReplacementAreaId,
      subAreasReplacementAreaUId,
    } = this.state;

    this.props.RemoveArea(
      areaId,
      areaUId,
      devicesReplacementAreaId,
      devicesReplacementAreaUId,
      subAreasReplacementAreaId,
      subAreasReplacementAreaUId,
      this.state.accessToken
    );

    this.setState({ isLoading: true }, () => {
      this.props.clearAll();
      this.props.getAll(this.state.accessToken);
      setTimeout(() => {
        this.props.navigation.navigate("Areas");
      }, 3000);
    });
  }

  render() {
    if (this.state.isLoading) return <Loading />;

    var _deviceTargetsToMove = [
      {
        label: this.state.parentName,
        value: this.state.parentId,
      },
    ];

    if (this.state.rootId && this.state.rootId != this.state.parentId) {
      _deviceTargetsToMove.push({
        label: this.state.rootName,
        value: this.state.rootId,
      });
    }
    return (
      <View style={styles.container}>
        {/* area name */}
        <Text style={styles.heading}>{this.state.areaName}</Text>
        {/* errors */}
        {this.state.errors.length > 0 && (
          <View style={[styles.sectionContainer, styles.errorsContainer]}>
            <SimpleIcon
              color={arTheme.COLORS.ERROR}
              icon={faExclamationTriangle}
              size={34}
            />
            <View>
              {this.state.errors.map((err, i) => (
                <Text style={styles.errorText} key={i}>
                  {err}
                </Text>
              ))}
            </View>
          </View>
        )}
        {/* subAreas */}
        {this.state.subAreas > 0 && this.state.hasParentAccess && (
          <View style={styles.sectionContainer}>
            <Select
              label={translate("area.moveSubAreasAfterRemoveTo")}
              data={[
                {
                  label: this.state.parentName,
                  value: this.state.parentId,
                },
              ]}
              value={this.state.subAreasReplacementAreaId || ""}
              onChangeText={(value, index, data) => {
                this.setState({ subAreasReplacementAreaId: value });
              }}
            />
          </View>
        )}
        {/* devices */}
        {this.state.devices > 0 &&
          (this.state.hasParentAccess || this.state.hasRootAccess) && (
            <View style={styles.sectionContainer}>
              <Select
                label={translate("area.moveDevicesAfterRemoveTo")}
                data={_deviceTargetsToMove}
                value={this.state.devicesReplacementAreaId || ""}
                onChangeText={(value, index, data) => {
                  this.setState({ devicesReplacementAreaId: value });
                }}
              />
            </View>
          )}
        <Text style={styles.errorText}>
          {"- "}
          {translate("area.DeleteAreaUsers")}
        </Text>
        <Text style={styles.errorText}>
          {"- "}
          {translate("area.DeleteAreaStates")}
        </Text>
        <Text style={styles.errorText}>
          {"- "}
          {translate("area.DeleteScenarios")}
        </Text>
        {/* confirm buttons */}
        <HStack
          space={2}
          style={{
            flex: 1,
            alignItems: "flex-end",
            // marginVertical: 10,
          }}
        >
          <ArButton
            mb="0"
            color="muted"
            onPress={() => {
              this.goBack();
            }}
            style={{ flex: 1 }}
          >
            {translate("app.goBack")}
          </ArButton>
          {this.state.errors.length == 0 && (
            <ArButton
              mb="0"
              color="error"
              onPress={() => {
                this.submit();
              }}
              style={{ flex: 1 }}
            >
              {translate("app.remove")}
            </ArButton>
          )}
        </HStack>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: { padding: 10, flex: 1 },
  heading: { textAlign: "center", fontWeight: "bold", fontSize: 18 },
  sectionContainer: {
    borderColor: arTheme.COLORS.BORDER,
    borderWidth: 1,
    padding: 10,
    borderRadius: 5,
    marginVertical: 10,
  },
  errorsContainer: {
    borderColor: arTheme.COLORS.ERROR,
    backgroundColor: arTheme.COLORS.ERROR + "11",
    flexDirection: "column",
    alignItems: "center",
  },
  errorText: {
    color: arTheme.COLORS.ERROR,
    paddingHorizontal: 5,
    marginBottom: 5,
  },
  dropdownLabel: { fontSize: 11, marginBottom: 10 },
});

function mapStateToProps(state) {
  return {
    AreaReducer: state.AreaReducer,
    AppReducer: state.AppReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAll: (accessToken) => dispatch(Actions.GetAll(accessToken)),
    clearAll: () => dispatch(Actions.ClearAll()),
    RemoveArea: (
      areaId,
      areaUId,
      devicesReplacementAreaId,
      devicesReplacementAreaUId,
      subAreasReplacementAreaId,
      subAreasReplacementAreaUId,
      accessToken
    ) =>
      dispatch(
        Actions.Remove(
          areaId,
          areaUId,
          devicesReplacementAreaId,
          devicesReplacementAreaUId,
          subAreasReplacementAreaId,
          subAreasReplacementAreaUId,
          accessToken
        )
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaRemoveScreen);
